import type { ProductAssignmentModel } from '@/shared/generated'

import { z } from 'zod'

import { filtersSchema } from '@/shared/components/filter/validation'

export const assignmentSchema = z.object({
	name: z.string().min(1),
	filters: filtersSchema.nonempty(),
})
export const assignmentsSchema = z.array(assignmentSchema).nonempty()

const matchedProductsRequestItemSchema = z.object({
	id: z.string().min(1),
	order: z.number(),
	assignments: z.array(
		z.object({
			id: z.string().min(1),
			filters: filtersSchema.nonempty(),
		})
	),
})
export const matchedProductsRequestSchema = z
	.array(matchedProductsRequestItemSchema)
	.nonempty()

type MatchedProductsRequestItem = z.infer<
	typeof matchedProductsRequestItemSchema
>
type MatchedProductsAssignmentModel = z.infer<typeof assignmentSchema>

export const isValidAssignment = (assignment: MatchedProductsAssignmentModel) =>
	assignmentSchema.safeParse(assignment).success

export const isValidAssignments = (assignments: ProductAssignmentModel) =>
	assignmentsSchema.safeParse(assignments).success

export const isValidMatchedProductsRequestItem = (
	assignment: MatchedProductsRequestItem
) => matchedProductsRequestItemSchema.safeParse(assignment).success
export const isValidMatchedProductsRequest = (
	assignments: MatchedProductsRequestItem[]
) => matchedProductsRequestSchema.safeParse(assignments).success
